import React from "react";
import { Link } from "react-router-dom";
import styles from "./footer.module.scss";

const Footer = () => {
  return (
    <footer className={styles.footer}>
      <div>
        <div className={styles.container}>
          <div className={styles.footerRow}>
            <div className={styles.column}>
              <div>
                <h6>
                  <Link to="/support" style={{ color: "white" }}>
                    WTD Noosa - App Support
                  </Link>
                </h6>
              </div>
              <ul>
                <li>
                  <div>
                    <a href="mailto:exempli.gratia.webdesign@gmail.com">
                      exempli.gratia.webdesign@gmail.com
                    </a>
                  </div>
                </li>
              </ul>
            </div>
            <div className={styles.column}></div>
            <div className={styles.column}>
              <div className={styles.socialTags}>
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href="https://www.facebook.com/ExempliGratia-Web-Design-101518322185096"
                >
                  Facebook
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div>
        <div>
          <div>
            <div>
              <p
                style={{
                  color: "#fefefe",
                  textAlign: "center",
                  margin: `${1}rem ${0} ${0} ${0}`,
                }}
              >
                Copyright &copy; 2021 All Rights Reserved by
                <span className={styles.copyRight}>
                  {" "}
                  <a
                    className={styles.copyRight}
                    href="https://www.eg-web-design.com/"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Exempli.Gratia web design
                  </a>
                </span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
